import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

const AuthorizationStatus = ({ allowClear = true,
  disabled, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      disabled={ disabled }
      allowClear={ allowClear }
      options={ [
        { text: t('fields.authorizationStatus.valid'), value: '1' },
        { text: t('fields.authorizationStatus.sus'), value: '2' },
        { text: t('fields.authorizationStatus.withdrawn'), value: '3' }
      ] }
    />
  );
};
export default AuthorizationStatus;
